// Danish

const lang = {
  gateMediaPreviewHeader: 'Du vil måske også kunne lide',
  loadmore: 'Vis mere',
  nextMedia: 'Næste medie',
  previousMedia: 'Tidligere medie',
  closePost: 'Luk indlæg',
  nextPost: 'Næste indlæg',
  previousPost: 'Forrige indlæg',
  outOfStock: 'Udsolgt',
  numberOfReviews(n) {
    return n === 1 ? 'anmeldelse' : 'anmeldelser'
  },
  reportFormField: 'Indtast en besked',
  reportPost: 'Rapportér indlæg',
  reportFormTitle: 'Ønsker du at rapportere dette billede?',
  reportFormDetails:
    'Hvis du mener at billedet er upassende, illegalt, eller krænker andres rettigheder, kan du rapportere indholdet. Hvis du rapporterer dette billede / denne tekst, bliver indholdsmoderatoren underrettet og de relevante foranstaltninger vil blive truffet.',
  reportFormMessagePlaceholder: 'Angiv din årsag til din rapport',
  reportFormMessageLabel: 'Besked',
  reportFormEmailLabel: 'Din e-mail',
  reportFormSubmitButtonText: 'Send rapport',
  reportFormCancelButtonText: 'Annuller',
  reportFormSentTitle: 'Tak for din rapport!',
  reportFormSentCloseButtonText: 'Luk',
  cardAndTileAriaLabel: 'Nedenfor er en liste over indlæg fra konti på forskellige sociale medier',
  carouselAriaLabel: 'Nedenfor er en karrusel med indlæg fra konti på forskellige sociale medier',
  singleAriaLabel: 'Nedenfor er et opslag fra en social mediekonto',
  poweredBy: 'Drevet af Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` offentliggjort på ${date}` : ''
    const createdByString = userName ? ` af ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Upload dine medier',
  openTheGate: 'Åbn dialogen',
}

export default lang
